import PasswordColor from './PasswordColour.svg';
import PasswordDark from './PasswordDark.svg';
import PasswordLight from './PasswordLight.svg';
export const password = {
    color: PasswordColor,
    dark: PasswordDark,
    light: PasswordLight
};
//# sourceMappingURL=index.js.map